import React, { useEffect, useState } from "react";

const TabellaIsee = (props) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  return (
    <>
      {width > 992 ? (
        <>
          {props.bands.bands && props.bands.bands.length > 0 ? (
            <>
              <h3 className="mt-4">
                Fasce ISEE
              </h3>
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th scope="col-2">Nome</th>
                    <th scope="col-2" className="text-right">Min</th>
                    <th scope="col-2" className="text-right">Max</th>
                    <th scope="col-2" className="text-right">Percentuale</th>
                    <th scope="col-2" className="text-right">Quota</th>
                    <th scope="col-2" className="text-right">Quota/h</th>
                  </tr>
                </thead>
                <tbody>
                  {props.bands.bands.map((x, index) => (
                    <tr key={index}>
                      <th scope="row">{x.name}</th>
                      <td className="text-right">
                        {parseFloat(x.min).toLocaleString("it-IT") + " €"}
                      </td>
                      <td className="text-right">
                        {parseFloat(x.max).toLocaleString("it-IT") + " €"}
                      </td>
                      <td className="text-right">
                        {x.percent
                          ? x.percent + "%"
                          : typeof x.percent != "object"
                          ? x.percent + "%"
                          : "N/A"}
                      </td>
                      <td className="text-right">
                        {x.fixedCost &&
                          parseFloat(x.fixedCost).toLocaleString("it-IT")} €
                      </td>
                      <td className="text-right">
                        {x.percent && x.fixedCost && !isNaN(parseFloat(x.percent)) && !isNaN(parseFloat(x.fixedCost))
                          ? (
                              (parseFloat(x.percent) / 100) * parseFloat(x.fixedCost)
                            ).toLocaleString("it-IT", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) + " €"
                          : "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          ) : (
            <>
              <span className="text mt-3">Non sono presenti fascee ISEE.</span>
            </>
          )}
        </>
      ) : (
        <>
          <div className="row">
            <div className="col-12">
              <h5 className="mt-4">
                <b>Fasce ISEE</b>
              </h5>
            </div>
          </div>
          {props.bands.bands &&
            props.bands.bands.map((x, index) => (
              <React.Fragment key={x.id}>
                <div className="row">
                  <div className="col-6">
                    <span>Nome:</span>
                  </div>
                  <div className="col-6">
                    <span>
                      <b>{x.name}</b>
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <span>Min:</span>
                  </div>
                  <div className="col-6">
                    <span>
                      <b>{parseFloat(x.min).toLocaleString("it-IT") + " €"}</b>
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <span>Max:</span>
                  </div>
                  <div className="col-6">
                    <span>
                      <b>{parseFloat(x.max).toLocaleString("it-IT") + " €"}</b>
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <span>Percentuale:</span>
                  </div>
                  <div className="col-6">
                    <span>
                      <b>
                        {x.percent
                          ? x.percent + "%"
                          : typeof x.percent != "object"
                          ? x.percent + "%"
                          : "NON PRESENTE"}
                      </b>
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <span>Quota:</span>
                  </div>
                  <div className="col-6">
                    <span>
                      <b>
                        {" "}
                        {parseFloat(x.fixedCost).toLocaleString("it-IT")} €
                      </b>
                    </span>
                  </div>
                </div>
              </React.Fragment>
            ))}
        </>
      )}
    </>
  );
};

export default TabellaIsee;
